import { render, staticRenderFns } from "./MailInfo.vue?vue&type=template&id=18aba0f2&"
import script from "./MailInfo.vue?vue&type=script&lang=js&"
export * from "./MailInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports